













































































































import { Component, Vue, Prop } from "vue-property-decorator";
import OkNgModal from "@/components/OkNgModal.vue";
import { Ticket } from "@/models/ticket";
import SystemConst from "@/config/const";
import firebase from "firebase/app";
import "firebase/firestore";
const db = firebase.firestore();
import TicketFavoriteService from "@/services/TicketFavoriteService";
import moment from "moment";

@Component({
  name: "TicketSalonTipComponent",
  components: {
    OkNgModal,
  },
})
export default class TicketSalonTipComponent extends Vue {
  @Prop({ default: new Ticket() }) pTicket!: Ticket;
  @Prop({ default: false }) secretSale!: boolean;

  SystemConst = SystemConst;
  faved = false;
  title = "";
  message = "";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  buy() {
    if (localStorage.uid) {
      this.$router.push({
        name: "TicketBuyOrder",
        params: {
          salonId: this.pTicket.salonId,
          ticketId: String(this.pTicket.number),
        },
      });
    } else {
      this.title = "購入にはログインが必要です";
      this.message =
        "チケットの購入をするには、favsalonの会員登録が必要になります。";
      this.refs.toLoginModal.open();
    }
  }

  async fav() {
    if (this.$store.getters.user.id) {
      this.faved = true;
      await TicketFavoriteService.createTicket({ ticket_id: this.pTicket.id });
    } else {
      this.title = "お気に入りにはログインが必要です";
      this.message =
        "お気に入り機能を利用するには、favsalonの会員登録が必要になります。";
      this.refs.toLoginModal.open();
    }
  }

  async unFav() {
    if (this.$store.getters.user.id) {
      this.faved = false;
      const uid = localStorage.uid;
      await TicketFavoriteService.deleteTicket(this.pTicket.id);
    } else {
      this.title = "お気に入りにはログインが必要です";
      this.message =
        "お気に入り機能を利用するには、favsalonの会員登録が必要になります。";
      this.refs.toLoginModal.open();
    }
  }

  async favedStatus() {
    if (this.$store.getters.user.id) {
      const response = await TicketFavoriteService.getTicket(this.pTicket.id);
      if (response.data.ticket_favorite) {
        this.faved = true;
      } else {
        this.faved = false;
      }
    }
  }

  gotoSignup() {
    this.$router.push({ name: "Signup" });
  }

  displayType(ticket: any) {
    let val = "";
    if (ticket.type == "ticket_service" && ticket.available_count == "1") {
      val = "single_item_service";
    } else {
      val = ticket.type;
    }
    const ticketType = SystemConst.TICKET_TYPE.find((e) => e.value == val);
    if (ticketType) {
      return ticketType.label;
    }
    return "";
  }

  displayDiscontinueOn(time: any) {
    if (time) {
      return moment(time).format("YYYY年 MM月DD日");
    }
    return '制限なし';
  }

  displayQuantity(ticket: any) {
    if (ticket.quantity) {
      return `${ticket.quantity - ticket.purchased_count}個`;
    }
    return '制限なし';
  }

  gotoLogin() {
    this.$router.push({ name: "Login" });
  }

  public created() {
    this.favedStatus();
  }
}
